/**
 * returned Orders endpoint instance
 * instantiate Order Invoice api class with a different api path
 */
import { ReturnedOrderEndpoints } from '@/modules/order-management/returned-order/api/returnedOrderEndpoints'

export const returnedOrderEndpoints = new ReturnedOrderEndpoints()
